<label class="anc-toggle" [class.anc-toggle--disabled]="disabled()">
    <input
        type="checkbox"
        role="switch"
        class="anc-toggle__input"
        [checked]="checked()"
        [disabled]="disabled()"
        [attr.aria-checked]="checked()"
        [attr.aria-label]="ariaLabel()"
        (change)="onChange($event)"
    />
    <span class="anc-toggle__track">
        <span class="anc-toggle__thumb"></span>
    </span>
</label>
